var freeProductRemove = JSON.parse(sessionStorage.getItem('freeProductRemove')) || [];

// Splide init
function mmInitSplide() {
	const id = '.mm-splide-crossell';
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: 'loop',
			arrows: true,
			pagination: false,
			gap: 19,
			perPage: 1,
			padding: {
				right: 110,
				left: 0,
			},
		}).mount();
	}
}

// Splide init
function mmInitSplide2() {
	const id = '.mm-splide-reassurance';
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: 'loop',
			arrows: false,
			pagination: true,
			perPage: 1,
			autoplay: true,
		}).mount();
	}
}

// PAck Splide init
function mmInitSplidePack() {
	const id = '.pack-cta-slider';
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: 'loop',
			arrows: false,
			pagination: false,
			perPage: 1,
			autoplay: true,
		}).mount();
	}
}

document.addEventListener(
	'DOMContentLoaded',
	() => {
		mmInitSplide();
		mmInitSplide2();
		mmInitSplidePack();
	},
	{ once: true }
);

function mmOpenPopupEmballage() {
    var popupEmballage = document.querySelector(".mm-popup-emballage");
    popupEmballage.classList.toggle("open");
}

function mmHandleEmballageSelection(event, emballageNumber) {
    const selectedVariantId = event.currentTarget.dataset.id;
    const isChecked = event.currentTarget.checked;

    // Identifie si les autres options d'emballage existent
    const option1Exists = document.getElementById('mm-option-emballage_1') !== null;
    const option2Exists = document.getElementById('mm-option-emballage_2') !== null;
    const option3Exists = document.getElementById('mm-option-emballage_3') !== null;

    // Pour les emballages 1 et 2, qui agissent comme des boutons radio
    if ((emballageNumber === 1 || emballageNumber === 2) && (option1Exists && option2Exists)) {
        const otherEmballageNumber = emballageNumber === 1 ? 2 : 1;
        const otherVariantIdElement = document.getElementById(`mm-option-emballage_${otherEmballageNumber}`);

        if (otherVariantIdElement) {
            const otherVariantId = otherVariantIdElement.dataset.id;
            const otherVariantInput = otherVariantIdElement;

            if (otherVariantInput.checked) {
                otherVariantInput.checked = false;
                mmRemoveProductQuantity(otherVariantId, false);
                updateEmballageState(otherVariantId, false);
            }
        }
    }

    // Gère l'ajout ou la suppression de produits pour toutes les options, y compris la 3
    if (isChecked) {
        mmAddProductToCart(selectedVariantId, { quantity: 1, openCart: false });
    } else {
        mmRemoveProductQuantity(selectedVariantId, false);
    }

    // Met à jour l'état dans le localStorage pour l'option actuelle
    updateEmballageState(selectedVariantId, isChecked);
}

function updateEmballageState(variantId, isChecked) {
    const emballageState = JSON.parse(localStorage.getItem('emballageState') || '{}');
    emballageState[variantId] = isChecked;
    localStorage.setItem('emballageState', JSON.stringify(emballageState));
}

function mmUpdateCheckboxStates() {
    const emballageState = JSON.parse(localStorage.getItem('emballageState') || '{}');

    [1, 2].forEach(emballageNumber => {
        const variantInput = document.getElementById(`mm-option-emballage_${emballageNumber}`);
        if (variantInput) {
            const variantId = variantInput.dataset.id;
            // Utiliser l'état sauvegardé s'il existe, sinon false par défaut
            variantInput.checked = emballageState[variantId] || false;
        }
    });
}

function mmDeleteProductEmballage(variantId, emballageNumber) {
    mmRemoveProductQuantity(variantId, false);
	updateEmballageState(variantId, false);
    document.getElementById(`mm-option-emballage_${emballageNumber}`).checked = false;
}

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function mmDebounce(func, duration) {
	let timeout;
	console.log('debounce', func, duration);
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart').id;
}

function mmCartSectionId() {
	return document.querySelector('.mm-cart').id.replace('shopify-section-', '');
}

function mmCartSectionElement() {
	return document.getElementById(`${mmCartSectionIdLong()}`);
}

function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
	return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
	const itemEl = mmCartItem(productVariantId);

	return itemEl.querySelector('[data-item-quantity]');
}

function mmGetCartItemQuantity(productVariantId) {
	const quantityEl = mmCartItemQuantityEl(productVariantId);

	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(productVariantId);

		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

function mmCartHTMLFromData(data) {
	const el = document.createElement('DIV');
	el.innerHTML = data.sections[mmCartSectionId()];

	return el;
}

function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector('.mm-dc-products-container');
}

function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

	return data;
}

function extractPackItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector('#mm-pack');
}

function insertPackProductsFromResponse(data) {
	const packContainer = extractPackItemsFromCartHTML(data);
	document.querySelector('#mm-pack').innerHTML = packContainer.innerHTML;

	return data;
}

function extractTotalPriceFromCartHTML(data, elem) {
	const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
	return cartEl.querySelector(elem);
}

function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data, '[data-cart-total-price]');
	const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
	const newTotalPriceReductionEl = extractTotalPriceFromCartHTML(data, '[data-cart-total-price-original]');
	const currentTotalPriceReductionEl = mmCartSectionElement().querySelector('[data-cart-total-price-original]');
	currentTotalPriceReductionEl.outerHTML = newTotalPriceReductionEl.outerHTML;
	return data;
}

function insertCartProductUpsellFromResponse(data) {
	mmCartSectionElement().querySelector('.mm-splide-crossell ul').innerHTML = mmCartHTMLFromData(data).querySelector('.mm-splide-crossell ul').innerHTML;
	mmInitSplide();
	return data;
}

function mmAPIRequest(method, path, body) {
	document.querySelector('.mm-dc-products').classList.add('mm-inactive');
	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(body),
	})
		.then((response) => response.json())
		.then((data) => {
			document.querySelector('.mm-dc-products').classList.remove('mm-inactive');
			var pb_notyet = document.querySelector('.mm-dc-free-item-progress-text_not_yet');
			var pb_success = document.querySelector('.mm-dc-free-item-progress-text_succes');
			var infoDelivery = document.querySelector('.mm-delivery-info');
			var pb = document.querySelector('.mm-dc-free-item-progress--inner');
			for (let index = listProgressBar.length; index > 0; index--) {
				if (data.total_price == 0) {
				}
				const element = listProgressBar[index - 1];
				if (index == listProgressBar.length && data.total_price >= element.amount * 100) {
					pb_success.innerHTML = element.text_success;
					pb_success.style.display = 'block';
					pb_notyet.style.display = 'none';
					pb.style.width = `100%`;
					if (infoDelivery != null) {
						infoDelivery.style.display = 'block';
					}
					break;
				} else if (data.total_price >= element.amount * 100) {
					var nextElement = listProgressBar[index];
					var reste = (nextElement.amount - data.total_price / 100).toFixed(0);
					var deviseActuelle = document.getElementById('deviseActuelle').innerText.trim();
					if (deviseActuelle === '£' || deviseActuelle == '$') {
						var montantAvecDevise = deviseActuelle + reste;
					} else {
						var montantAvecDevise = reste + ' ' + deviseActuelle;
					}
					var diff = nextElement.amount - element.amount;
					pb_notyet.innerHTML = nextElement.text.replace('[montant]', "<span class='mm-cart-montant-restant-minus'>" + montantAvecDevise + '</span>');
					pb_success.style.display = 'none';
					pb_notyet.style.display = 'block';
					const newWidth = ((diff - reste) / diff) * 100;
					pb.style.width = `${newWidth}%`;
					if (nextElement.infoDelivery != null) {
						infoDelivery.style.display = 'block';
					} else {
						infoDelivery.style.display = 'none';
					}
					break;
				} else if (index == 1) {
					var reste = (element.amount - data.total_price / 100).toFixed(0);
					var deviseActuelle = document.getElementById('deviseActuelle').innerText.trim();
					if (deviseActuelle == '£' || deviseActuelle == '$') {
						var montantAvecDevise = deviseActuelle + reste;
					} else {
						var montantAvecDevise = reste + ' ' + deviseActuelle;
					}
					var diff = element.amount;
					pb_notyet.innerHTML = element.text.replace('[montant]', "<span class='mm-cart-montant-restant-minus'>" + montantAvecDevise + '</span>');
					pb_success.style.display = 'none';
					pb_notyet.style.display = 'block';
					const newWidth = ((diff - reste) / diff) * 100;
					pb.style.width = `${newWidth}%`;
					if (element.infoDelivery != null) {
						infoDelivery.style.display = 'block';
					} else {
						infoDelivery.style.display = 'none';
					}
				}
			}
			mmAddOrRemoveFreeProducts(data);
			updateCartCount(data.item_count != null ? data.item_count : 0);
			return data;
		})
		.then((data) => {
			if (data.status && data.status > 400) {
				throw data;
			} else {
				return data;
			}
		});
}

// récupérer le panier
function mmGetCart() {
	mmAPIRequest('GET', 'cart.js').then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
	document.querySelector('.mm-drawer-cart-filter').classList.add('mm-dc-is-open');
	document.querySelector('html').classList.add('stop-scrolling');
}

// Fermer le panier
function mmCloseCart() {
	document.querySelector('.mm-drawer-cart-filter').classList.remove('mm-dc-is-open');
	document.querySelector('html').classList.remove('stop-scrolling');
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
	const newCartEl = document.createElement('DIV');
	newCartEl.innerHTML = data.sections[mmCartSectionId()];

	const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart-filter');
	const packCart = mmCartSectionElement().querySelector('.mm-pack');

	innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart-filter').innerHTML;
	if (packCart) {
		packCart.innerHTML = newCartEl.querySelector('.mm-pack').innerHTML;
	}

	updateCartCount(newCartEl.querySelector('[data-cart-count]').dataset.cartCount);
	mmInitSplide();
	mmInitSplide2();
	mmInitSplidePack();
	mmUpdateCheckboxStates();
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
	mmAPIRequest('POST', 'cart/add.js', {
		items: [{ quantity: quantity, id: productId }],
		sections: mmCartSectionId(),
	})
		.then(refreshCartFromData)
		.then((data) => {
			if (openCart) {
				setTimeout(mmOpenCart);
			}
		})
		.catch((error) => {
			alert("Impossible d'ajouter au panier. Il est possible que ce produit soit indisponible");
			mmOpenCart();
			console.log(error);
		});
}

function mmIncreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity + 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity - 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmRemoveProductQuantity(productVariantId, isfreeProduct) {
	const newQuantity = 0;
	mmSetCartItemQuantity(productVariantId, newQuantity);
	if (isfreeProduct) {
		freeProductRemove.push(productVariantId);
		sessionStorage.setItem('freeProductRemove', JSON.stringify(freeProductRemove));
	}
	mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);

	mmAPIRequest('POST', 'cart/change.js', {
		id: productVariantId.toString(),
		quantity: quantity,
		sections: mmCartSectionId(),
	})
		.then(insertCartProductUpsellFromResponse)
		.then(mmAddOrRemoveFreeProducts)
		.then(insertInsertTotalPriceFromResponse)
		.then(insertCartProductsFromResponse)
        .then(insertPackProductsFromResponse)
		.then(mmInitSplidePack);
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
	mmPushNewQuantity(productVariantId);
}, 300);

function mmAddOrRemoveFreeProducts(data) {
	if (data.sections[mmCartSectionId()]) {
		const el = mmCartHTMLFromData(data);
		const freeProductEls = el.querySelector('[data-free-products]');
		let freeProductCounts = 0;

		// creates an object like { 44058675: 1, 44058001: 0 }
		// where key is free product id and value, its quantity
		const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
			const productId = freeProductEl.dataset.productId;
			const isFree = freeProductEl.dataset.freeProduct == 'true';
			const itemEl = mmCartItem(productId);
			const isfreeProductremove = freeProductRemove.includes(parseInt(productId));

			if (isFree) {
				freeProductCounts += 1;
			}
			if (itemEl && isFree && !isfreeProductremove) {
				// do nothing, item is already added
			} else if ((itemEl && !isFree) || (itemEl && isfreeProductremove)) {
				// item is present but should be removed
				param[productId] = 0;
			} else if (!itemEl && isFree && !isfreeProductremove) {
				// item is absent but should be added
				param[productId] = 1;
			}
			return param;
		}, {});

		// Add or remove free products only if needed
		if (Object.keys(productsParams).length > 0) {
			mmAPIRequest('POST', 'cart/update.js', { updates: productsParams, sections: mmCartSectionId() }).then(insertCartProductsFromResponse);
		}
	}
	return data;
}

document.addEventListener("DOMContentLoaded", function() {
	const title = document.getElementById('mm-pack-title');
	const content = document.querySelector('.mm-pack-content');
	const cta = document.querySelector('.mm-pack-cta-wrapper');

	title.addEventListener('click', function() {
		const arrow = title.querySelector('.mm-pack-toggle-arrow .icon-caret');
		
		if (content.style.maxHeight) {
			content.style.maxHeight = null;
			arrow.style.transform = "rotate(180deg)";
		} else {
			content.style.maxHeight = cta.scrollHeight + "px";
			arrow.style.transform = "rotate(0)";
		}
	});
});

// PROGRESS BAR
function mmProgressBar() {}

function updateCartCount(value) {
	document.querySelector('.mm-cart-header-count').innerHTML = '&nbsp;(' + value + ')';
	document.querySelector('.mm-cart-count-bubble-value').innerText = value;
}
